import React, { useState } from 'react'
import { IconButton, Dialog, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import DialogView from '../../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'

function DeleteDemoraEnVolcadora (props) {
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const onDelete = () => {
    props.deleteDemora()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='sm'
      >
        <DialogView
          confirmCallback={onDelete}
          cancelCallback={handleClose}
          title='Eliminar demora en volcadora'
          content={<DialogConfirmacionContent
            message='¿Está seguro que desea eliminar la demora en volcadora seleccionada?'
          />
          }
        />
      </Dialog>

      <Tooltip title={'Eliminar'}>
        <IconButton onClick={handleOpen}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default DeleteDemoraEnVolcadora
